//[
//    {
//        "id": "string",
//        "status": "string",
//        "statusFrom": "2017-10-08T10:46:38.832Z",
//        "title": "string",
//        "firstName": "string",
//        "middleName": "string",
//        "lastName": "string",
//        "dob": "2017-10-08T10:46:38.833Z",
//        "sex": "string",
//        "notes": "string",
//        "imageId": "string",
//        "allergies": "string",
//        "nhsNumber": "string",
//        "generalPractitioner": {
//            "name": "string",
//            "address": "string",
//            "postCode": "string",
//            "phoneNumber": "string"
//        },
//        "roomNumber": "string",
//        "wardId": "string",
//        "whoUpdated": "string",
//        "whenUpdated": "2017-10-08T10:46:38.833Z",
//        "whenCreated": "2017-10-08T10:46:38.833Z"
//    }
//]

export class GeneralPractitioner{
    name: string;
    address: string;
    postCode: string;
    phoneNumber: string
}

export class PatientDto {
    constructor()
    {
        this.wardName = "";
        this.carehomeName = "";
    }

    id: string;
    status: string;
    statusFrom: Date;
    title: string;
    firstName: string;
    middleName: string;
    lastName: string;
    dob: Date;
    sex: string;
    notes: string;
    imageId: string;
    imageData: string;
    pharmacyPatientId: string;
    allergies: string;
    nhsNumber: string;
    generalPractitioner: GeneralPractitioner;
    roomNumber: string;
    wardId: string;
    wardName: string;
    carehomeId: string;
    carehomeName: string;
    whoUpdated: string;
    whenUpdated: Date;
    whenCreated: Date;
}


// WEBPACK FOOTER //
// ./ClientApp/dto/PatientDto.ts